import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PropertiesService} from "./properties.service";
import {BehaviorSubject, Observable} from "rxjs";
import {BaseValidationResponse, Validazioni} from "../interfaces/utilities";

@Injectable({
	providedIn: 'root'
})
export class ValidationService {

	validatorsList = new BehaviorSubject<Validazioni[]>(null);
	private _subValidators = this.validatorsList.subscribe(data=>{
		if(data !== null){
			return data;
		}
	});

	constructor(private http: HttpClient,
				private propService: PropertiesService) {
	}


	getValidationsList(): Observable<BaseValidationResponse> {
		return this.http.get<BaseValidationResponse>(this.propService.getProp('apiPrefix') + '/api/Public/Servizi/ListaValidazioni');
	}

}
